import { ChangeEvent, LegacyRef } from 'react';

import { ReactComponent as ArrowUp } from 'utils/assets/images/arrow-up-no-bg.svg';
import { ReactComponent as Trash } from 'utils/assets/images/trash.svg';

import { useCropImageContext } from '../useCropImageContext/useCropImageContext';
import { ACCEPTED_IMG_TYPES, BUTTON_LOAD_IMG, BUTTON_REMOVE_IMG } from '../utils/constants';

import styles from './FileButton.module.scss';

interface IFileButton {
  inputRef?: LegacyRef<HTMLInputElement>;
  onLoadImage: (e: ChangeEvent<HTMLInputElement>) => void;
  onRemoveImage: () => void;
}

export const FileButton = ({ inputRef, onLoadImage, onRemoveImage }: IFileButton) => {
  const { imageUrl, isLoadingImage } = useCropImageContext();

  return !imageUrl || isLoadingImage ? (
    <div className={styles.file__input}>
      <label className={styles.file__input__label} htmlFor='image'>
        {BUTTON_LOAD_IMG} <ArrowUp />
      </label>
      <input
        ref={inputRef}
        className={styles.file__input__file}
        id='image'
        type='file'
        max={1}
        accept={ACCEPTED_IMG_TYPES}
        disabled={isLoadingImage}
        onChange={onLoadImage}
      />
    </div>
  ) : (
    <div className={styles.file__input}>
      <button className={styles.file__input__btn} onClick={onRemoveImage}>
        {BUTTON_REMOVE_IMG} <Trash />
      </button>
    </div>
  );
};
